import type { Lang } from "../i18n";
import { t } from "../i18n";
import { Footer } from "./Footer";
import { Nav } from "./Nav";

export function RouteLoadingPage({ lang, kind }: { lang: Lang; kind: "demo" | "diagnostics" }) {
  const isDemo = kind === "demo";
  const title = isDemo
    ? t(lang, "demo.preview.title")
    : lang === "zh"
      ? "正在加载演示诊断"
      : "Loading demo diagnostics";
  const description = isDemo
    ? t(lang, "demo.preview.subtitle")
    : lang === "zh"
      ? "正在准备连接状态和调试信息。"
      : "Preparing connection status and diagnostic information.";

  return (
    <div className="min-h-screen bg-[#f8f9fa] font-sans text-[#100f12]">
      <Nav lang={lang} />
      <main className="relative overflow-hidden px-5 pt-32 sm:px-10 lg:pt-36">
        <div
          className="pointer-events-none absolute inset-x-0 top-0 h-[680px]"
          style={{
            background:
              "radial-gradient(circle at 18% 2%, rgba(153, 108, 255, .10), transparent 24%), radial-gradient(circle at 82% 4%, rgba(233, 48, 201, .07), transparent 26%), linear-gradient(180deg, #fff 0%, rgba(248,249,250,.98) 60%, #f8f9fa 100%)",
          }}
        />
        <section className="relative mx-auto flex min-h-[560px] max-w-[1180px] flex-col items-center justify-center pb-20 text-center">
          <div className="inline-flex rounded-full bg-[#f3eefa] px-3 py-1 text-[12px] font-extrabold uppercase tracking-[0.12em] text-[#5223b1]">
            ClawEase
          </div>
          <h1 className="mt-5 max-w-[920px] text-[34px] font-black leading-[1.04] tracking-[-0.04em] text-[#100f12] sm:text-[48px] lg:text-[56px]">
            {title}
          </h1>
          <p className="mt-5 max-w-[680px] text-[15px] font-semibold leading-7 text-[#775f78]">{description}</p>
          <div className="mt-8 h-2 w-36 overflow-hidden rounded-full bg-[#eadff2]" aria-label={lang === "zh" ? "正在加载" : "Loading"}>
            <div className="h-full w-1/2 animate-pulse rounded-full bg-gradient-to-r from-[#5223b1] to-[#e930c9]" />
          </div>
        </section>
      </main>
      <Footer lang={lang} />
    </div>
  );
}
